import PanelsDevelopmentMethodology from './PanelsDevelopmentMethodology'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

const mapStateToProps = state => {
    return {}
  }

export default withRouter(
    connect(
        mapStateToProps
    )(PanelsDevelopmentMethodology)
);


// WEBPACK FOOTER //
// ./src/modules/PanelsDevelopmentMethodology/index.js